// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%2710%27 fill=%27green%27><polygon points=%275,0 0,10 10,10%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%2710%27 fill=%27red%27><polygon points=%270,0 10,0 5,10%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.borsatable td {
    font-size: 16px;
    text-align: right;
    border: 1px solid;
    border-left-color: #ccc;
    border-right-color: #ccc;
    border-bottom: solid 2px;
}

@keyframes redflash {
    to {
        background-color: #FFCDD2;
    }
}

@keyframes greenflash {
    to {
        background-color: #C8E6C9;
    }
}

.redflash {
    animation: redflash 1s 2 alternate ease-out;
    color: red;
}

.greenflash {
    animation: greenflash 1s 2 alternate ease-out;
    color: green;
}

td.custom {
    font-weight: 600;
    color: #0f00d7;
}

@media print {
    .borsatable td {
        font-size: 12px;
    }

    .hide-on-print {
        display: none !important;
    }
}

table.btable td {
    border: 1px solid !important;
    text-align: center;
}

.BIST100 {
    background-color: #DDD;
    font-weight: bolder;
    font-size: 18px !important;
}

.BISTYUZDE {
    font-weight: bolder;
    font-size: 18px !important;
}

td.greenflash {
    padding-left: 18px;
}

td.redflash {
    padding-left: 18px;
}

td.greenflash::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

td.redflash::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

td.greenflash::before,
td.redflash::before {
    left: 5px;
    position: absolute;
}

table.btable td {
    position: relative;
}

.borsa-wrap .text-center {
    text-align: center;
}

.borsa-wrap table {
    z-index: 0;
}

.borsa-wrap .btns {
    z-index: 999;
}

.borsa-wrap .borsa-actions {
    position: relative;
    margin-bottom: 8px;
}

.borsa-wrap .borsa-actions .ant-btn {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    min-width: 50px;
    padding: 0;
    font-size: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.borsa-wrap .borsa-actions .ant-btn .anticon {
    font-size: 20px;
}

.borsa-wrap .borsa-actions .borsa-btn-excel.ant-btn-default {
    border-color: #52c41a;
    color: #52c41a;
}

.borsa-wrap .borsa-actions .borsa-btn-excel.ant-btn-default:hover {
    border-color: #73d13d;
    color: #73d13d;
}

.borsa-wrap .borsa-table-wrap {
    max-width: 100%;
    overflow-x: auto;
}

.borsa-wrap .borsatable {
    width: 100%;
    min-width: 0;
    border-collapse: collapse;
    table-layout: fixed;
}

.borsa-wrap .borsatable td {
    padding: 4px 6px;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.borsa-wrap .borsatable h3 {
    font-size: 14px;
    margin: 4px 0;
}

.borsa-wrap .borsatable .BIST100 {
    font-size: 14px !important;
}

.borsa-wrap .borsatable tr.total td {
    font-weight: 600;
}

/* Borsa Günlük: tablo sayfaya sığsın, daha küçük font/padding */
.borsa-gunluk-wrap {
    padding: 8px;
    max-width: 100%;
    box-sizing: border-box;
}

.borsa-gunluk-wrap .borsa-table-wrap {
    max-width: 100%;
    max-height: calc(100vh - 140px);
    overflow: auto;
}

.borsa-gunluk-wrap .borsatable {
    table-layout: fixed;
    width: 100%;
}

.borsa-gunluk-wrap .borsatable td {
    font-size: 11px;
    padding: 3px 4px;
    line-height: 1.2;
}

.borsa-gunluk-wrap .borsatable td.greenflash,
.borsa-gunluk-wrap .borsatable td.redflash {
    padding-left: 18px;
}

.borsa-gunluk-wrap .borsatable td:nth-child(1) {
    min-width: 48px;
    max-width: 72px;
}

.borsa-gunluk-wrap .borsatable h1 {
    font-size: 14px;
    margin: 4px 0;
}

.borsa-gunluk-wrap .BIST100,
.borsa-gunluk-wrap .BISTYUZDE {
    font-size: 12px !important;
}

.tradingview-widget-container {
    height: 500px;
    width: 100%;
}

.tradingview-widget-container iframe {
    width: 100%;
    height: 100%;
}

.borsa-pdf-capture {
    width: max-content !important; 
    max-width: none !important;
    overflow: visible !important; 
}

.borsa-pdf-capture table {
    width: max-content !important; 
    max-width: none !important;
    table-layout: auto !important;
}

.borsa-pdf-capture table td, 
.borsa-pdf-capture table th {
    font-size: 10px !important; 
    padding: 3px !important; 
    white-space: nowrap !important;
}`, "",{"version":3,"sources":["webpack://./src/components/borsa/Borsa.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,2CAA2C;IAC3C,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gDAA4J;AAChK;;AAEA;IACI,gDAAyJ;AAC7J;;AAEA;;IAEI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,gEAAgE;AAChE;IACI,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;IAEI,0BAA0B;IAC1B,uBAAuB;IACvB,8BAA8B;AAClC","sourcesContent":[".borsatable td {\n    font-size: 16px;\n    text-align: right;\n    border: 1px solid;\n    border-left-color: #ccc;\n    border-right-color: #ccc;\n    border-bottom: solid 2px;\n}\n\n@keyframes redflash {\n    to {\n        background-color: #FFCDD2;\n    }\n}\n\n@keyframes greenflash {\n    to {\n        background-color: #C8E6C9;\n    }\n}\n\n.redflash {\n    animation: redflash 1s 2 alternate ease-out;\n    color: red;\n}\n\n.greenflash {\n    animation: greenflash 1s 2 alternate ease-out;\n    color: green;\n}\n\ntd.custom {\n    font-weight: 600;\n    color: #0f00d7;\n}\n\n@media print {\n    .borsatable td {\n        font-size: 12px;\n    }\n\n    .hide-on-print {\n        display: none !important;\n    }\n}\n\ntable.btable td {\n    border: 1px solid !important;\n    text-align: center;\n}\n\n.BIST100 {\n    background-color: #DDD;\n    font-weight: bolder;\n    font-size: 18px !important;\n}\n\n.BISTYUZDE {\n    font-weight: bolder;\n    font-size: 18px !important;\n}\n\ntd.greenflash {\n    padding-left: 18px;\n}\n\ntd.redflash {\n    padding-left: 18px;\n}\n\ntd.greenflash::before {\n    content: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='green'><polygon points='5,0 0,10 10,10'/></svg>\");\n}\n\ntd.redflash::before {\n    content: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='red'><polygon points='0,0 10,0 5,10'/></svg>\");\n}\n\ntd.greenflash::before,\ntd.redflash::before {\n    left: 5px;\n    position: absolute;\n}\n\ntable.btable td {\n    position: relative;\n}\n\n.borsa-wrap .text-center {\n    text-align: center;\n}\n\n.borsa-wrap table {\n    z-index: 0;\n}\n\n.borsa-wrap .btns {\n    z-index: 999;\n}\n\n.borsa-wrap .borsa-actions {\n    position: relative;\n    margin-bottom: 8px;\n}\n\n.borsa-wrap .borsa-actions .ant-btn {\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    min-width: 50px;\n    padding: 0;\n    font-size: 20px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.borsa-wrap .borsa-actions .ant-btn .anticon {\n    font-size: 20px;\n}\n\n.borsa-wrap .borsa-actions .borsa-btn-excel.ant-btn-default {\n    border-color: #52c41a;\n    color: #52c41a;\n}\n\n.borsa-wrap .borsa-actions .borsa-btn-excel.ant-btn-default:hover {\n    border-color: #73d13d;\n    color: #73d13d;\n}\n\n.borsa-wrap .borsa-table-wrap {\n    max-width: 100%;\n    overflow-x: auto;\n}\n\n.borsa-wrap .borsatable {\n    width: 100%;\n    min-width: 0;\n    border-collapse: collapse;\n    table-layout: fixed;\n}\n\n.borsa-wrap .borsatable td {\n    padding: 4px 6px;\n    font-size: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.borsa-wrap .borsatable h3 {\n    font-size: 14px;\n    margin: 4px 0;\n}\n\n.borsa-wrap .borsatable .BIST100 {\n    font-size: 14px !important;\n}\n\n.borsa-wrap .borsatable tr.total td {\n    font-weight: 600;\n}\n\n/* Borsa Günlük: tablo sayfaya sığsın, daha küçük font/padding */\n.borsa-gunluk-wrap {\n    padding: 8px;\n    max-width: 100%;\n    box-sizing: border-box;\n}\n\n.borsa-gunluk-wrap .borsa-table-wrap {\n    max-width: 100%;\n    max-height: calc(100vh - 140px);\n    overflow: auto;\n}\n\n.borsa-gunluk-wrap .borsatable {\n    table-layout: fixed;\n    width: 100%;\n}\n\n.borsa-gunluk-wrap .borsatable td {\n    font-size: 11px;\n    padding: 3px 4px;\n    line-height: 1.2;\n}\n\n.borsa-gunluk-wrap .borsatable td.greenflash,\n.borsa-gunluk-wrap .borsatable td.redflash {\n    padding-left: 18px;\n}\n\n.borsa-gunluk-wrap .borsatable td:nth-child(1) {\n    min-width: 48px;\n    max-width: 72px;\n}\n\n.borsa-gunluk-wrap .borsatable h1 {\n    font-size: 14px;\n    margin: 4px 0;\n}\n\n.borsa-gunluk-wrap .BIST100,\n.borsa-gunluk-wrap .BISTYUZDE {\n    font-size: 12px !important;\n}\n\n.tradingview-widget-container {\n    height: 500px;\n    width: 100%;\n}\n\n.tradingview-widget-container iframe {\n    width: 100%;\n    height: 100%;\n}\n\n.borsa-pdf-capture {\n    width: max-content !important; \n    max-width: none !important;\n    overflow: visible !important; \n}\n\n.borsa-pdf-capture table {\n    width: max-content !important; \n    max-width: none !important;\n    table-layout: auto !important;\n}\n\n.borsa-pdf-capture table td, \n.borsa-pdf-capture table th {\n    font-size: 10px !important; \n    padding: 3px !important; \n    white-space: nowrap !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
